import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, unref as _unref, createVNode as _createVNode, createBlock as _createBlock, resolveComponent as _resolveComponent, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "requested-column" }
const _hoisted_2 = { class: "type-column" }
const _hoisted_3 = {
  key: 0,
  class: "timeframe-column"
}
const _hoisted_4 = {
  key: 1,
  class: "expiry-column"
}
const _hoisted_5 = { class: "action-column" }
const _hoisted_6 = { class: "export-table-row__collapsed-container" }

import { computed, type PropType } from 'vue';
import { useI18n } from 'vue-i18n';

import useMQBreakpoints from '@exchange/libs/composables/shared/src/lib/useMQBreakpoints';
import { type ExportItem, ExportState, ExportType } from '@exchange/libs/exports/service/src';
import { CONSTANTS } from '@exchange/libs/utils/constants/src';

import CollapsedExportItemRecord from './CollapsedExportItemRecord.vue';
import ExportItemDownload from './ExportItemDownload.vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'ExportTableRow',
  props: {
  collapsed: { type: Boolean, required: true },
  downloadItem: { type: Function as PropType<(id: string, isTradeItem: boolean) => Promise<void>>, required: true },
  fetchItem: { type: Function as PropType<(id: string, isTradeItem: boolean) => Promise<void>>, required: true },
  getLocalTime: { type: Function as PropType<(utcDateString: string, formatString?: string) => string>, required: true },
  item: { type: Object as PropType<ExportItem>, required: true },
},
  setup(__props) {

const props = __props;

const { t } = useI18n({ useScope: 'global' });

const { isMD, isLG, isXL } = useMQBreakpoints();
const bigScreen = computed(() => isLG.value || isXL.value);

const formattedTime = (time: string) => props.getLocalTime(time, CONSTANTS.DATE_FORMAT);
const getItemsToShow = (arr: Array<string>, emptyIsAll = false) => {
  if (arr.length) {
    return [...arr]
      .sort((a, b) => a.localeCompare(b))
      .map((e) => e.replace(/_/g, '/'))
      .join(', ');
  }

  return t(emptyIsAll ? 'fundamentals.all' : 'fundamentals.emptyValues.default');
};

const created = computed(() => formattedTime(props.item.created));
const expiration = computed(() => {
  if (props.item.state === ExportState.inProgress) {
    return t('fundamentals.emptyValues.default');
  }

  return formattedTime(props.item.expiration);
});
const timeFrame = computed(() => {
  const { to, from } = props.item;
  const dateFormat = CONSTANTS.HISTORY_DROPDOWN_DISPLAYED_DATE_FORMAT_COMPACT;

  if (to && from) {
    const showTo = props.getLocalTime(to, dateFormat);
    const showFrom = props.getLocalTime(from, dateFormat);

    return `${showFrom} - ${showTo}`;
  }

  return t('modules.accountHistory.export.fullHistory');
});
const accounts = computed(() => getItemsToShow(props.item.accounts));
const markets = computed(() => getItemsToShow(props.item.markets, props.item.type === ExportType.trades));
const currencies = computed(() => getItemsToShow(props.item.currencies));

return (_ctx: any,_cache: any) => {
  const _component_ot_grid_table_row = _resolveComponent("ot-grid-table-row")!

  return (_openBlock(), _createBlock(_component_ot_grid_table_row, {
    class: "export-table-row",
    collapsed: __props.collapsed
  }, {
    collapsed: _withCtx(() => [
      _createElementVNode("div", _hoisted_6, [
        (!bigScreen.value)
          ? (_openBlock(), _createBlock(CollapsedExportItemRecord, {
              key: 0,
              label: _ctx.$t('modules.exports.table.headers.timeframe'),
              value: timeFrame.value
            }, null, 8, ["label", "value"]))
          : _createCommentVNode("", true),
        _createVNode(CollapsedExportItemRecord, {
          label: _ctx.$t('modules.exports.table.headers.accounts'),
          value: accounts.value
        }, null, 8, ["label", "value"]),
        _createVNode(CollapsedExportItemRecord, {
          label: _ctx.$t('modules.exports.table.headers.markets'),
          value: markets.value
        }, null, 8, ["label", "value"]),
        _createVNode(CollapsedExportItemRecord, {
          label: _ctx.$t('modules.exports.table.headers.currencies'),
          value: currencies.value
        }, null, 8, ["label", "value"]),
        (!(_unref(isMD) || bigScreen.value))
          ? (_openBlock(), _createBlock(CollapsedExportItemRecord, {
              key: 1,
              label: _ctx.$t('modules.exports.table.headers.expiry'),
              value: expiration.value
            }, null, 8, ["label", "value"]))
          : _createCommentVNode("", true)
      ])
    ]),
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("span", null, _toDisplayString(created.value), 1)
      ]),
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("span", null, _toDisplayString(_ctx.$t(`modules.exports.type.${__props.item.type}`)), 1)
      ]),
      (bigScreen.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _createElementVNode("span", null, _toDisplayString(timeFrame.value), 1)
          ]))
        : _createCommentVNode("", true),
      (_unref(isMD) || bigScreen.value)
        ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
            _createElementVNode("span", null, _toDisplayString(expiration.value), 1)
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_5, [
        _createVNode(ExportItemDownload, {
          class: "export-table-row__download",
          item: __props.item,
          "fetch-item": __props.fetchItem,
          "download-item": __props.downloadItem
        }, null, 8, ["item", "fetch-item", "download-item"])
      ])
    ]),
    _: 1
  }, 8, ["collapsed"]))
}
}

})